export const REAL_TIME = "REAL_TIME";
export const PERIODIC = "PERIODIC";

export const REAL_TIME_RULE_OPTIONS = [
  {
    label: "Real Time",
    value: REAL_TIME,
  },
];

export const PERIODIC_RULE_OPTIONS = [
  {
    label: "Periodic",
    value: PERIODIC,
  },
];

export const LIST = "list";
export const ID = "id";
export const GL_MASTER = "communityGlMasterId";
export const GL_DESC = "accountShortDesc";
export const GL_ACC = "glAccountNumber";
export const CATEGORY = "accountCategory";
export const YEAR = "year";
export const DISTRIBUTION_TIME = "distributionTiming";
export const PLAN_GROUP_DISTRIBUTION_GL = "planGroupDistributionGlId";
export const ACTUAL_GROUP_DISTRIBUTION_GL = "actualGroupDistributionGlId";
export const PLAN_ZONE = "planZoneRuleId";
export const PLAN_BLOCK = "planBlockRuleId";
export const PLAN_PROPERTY = "planPropertyRuleId";
export const ACTUAL_ZONE = "actualZoneRuleId";
export const ACTUAL_BLOCK = "actualBlockRuleId";
export const ACTUAL_PROPERTY = "actualPropertyRuleId";
export const ACTUAL_DISTRIBUTED = "actualDistributed";